<template>
  
</template>

<script>
export default {
  created() {
  },
  mounted() {
  },
  data() {
    return {
     
    };
  },
  methods: {
  },
  components: {
  },
  props: {
    
  },
  watch: {
  },
  computed: {
   
  },

};
</script>

<style>

</style>